import React, { useEffect, useState } from 'react';
import Page from '@Containers/Page';
import { HashRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import HeaderContainer from '@Pages/History/HeaderContainer';
import { paths } from '@AppRoutes/constants';
import NewRelicService from '@Services/NewRelicService';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import HistoryRecent from './HistoryRecent';
import HistorySaved from './HistorySaved';

import './History.scss';
import './HistoryModal.scss';

export default function HistoryContainer() {
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState(location);

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    setCurrentLocation(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentLocation !== location) {
      NewRelicService.trackRouteChanges(location.pathname);
    }
    RouteChangeTracking.handleSkipLinkFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Page withFooter>
      <div id="history" className="history-main-wrapper u-els-background-color-n0">
        <main id="main-content" aria-labelledby="history-title">
          <HeaderContainer />
          <section className="history-page rx-left-gutter rx-right-gutter rx-list-wrapper">
            <Router>
              <Switch>
                <Route path={paths.HISTORY_RECENT} render={() => <HistoryRecent />} />
                <Route path={paths.HISTORY_SAVED} render={() => <HistorySaved />} />
              </Switch>
            </Router>
          </section>
        </main>
      </div>
    </Page>
  );
}
